import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Banners } from "../../constants/banners";
import "swiper/css";
import "swiper/css/pagination";
import styles from "./BannerSlider.module.scss";

// Configurações do Swiper
const swiperConfig = {
  spaceBetween: 0,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    clickable: true,
  },
  modules: [Autoplay, Pagination],
};

// Componente para o slide do banner
const BannerSlide = ({ image, title, description }) => (
  <div className={styles.slide}>
    <img
      src={image}
      alt={title}
      className={styles.slideImage}
      loading="lazy"
    />
    <div className={styles.textOverlay}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

/**
 * Componente principal do BannerSlider
 * @returns {JSX.Element} Componente de slider para o banner de autenticação
 */
const BannerSlider = () => {
  return (
    <div className={styles.sliderContainer}>
      <Swiper {...swiperConfig}>
        {Banners.map((slide, index) => (
          <SwiperSlide key={index}>
            <BannerSlide
              image={slide.image}
              title={slide.title}
              description={slide.description}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BannerSlider;